// PRIVATE functions:
function guessClient(groups) { 
  return groups.find(x => x.KpiGroupName == 'Process Excellence') ? true : false;
};

function selectItem(groups, isBMW) {
  let selected = null;
  if (isBMW) {
    selected = groups.find(x => x.KpiGroupName == 'Process Excellence');
  } else {
    selected = groups.find(x => x.KpiGroupName == 'Customer Experience Check-up');
  }
  return selected ? selected : groups[0];
};

// For BMW/MINI:
// 1. 'Process Excellence' without children!
// 2. all children of 'Process Excellence' on root level
// 3. all children of 'Legendary Moment' on root level
// 4. 'Digital Readiness'
// 5. 'Excitement'
function getBmwKpiCollection(groups) {
  let options = [];
  let pe = { ...groups.find(x => x.KpiGroupName == 'Process Excellence') };
  pe.children = undefined;
  options.push(pe);
  groups.find(x => x.KpiGroupName == 'Process Excellence').children
    .forEach(pe => {
      pe.KpiGroupName = 'Process Excellence';
      options.push(pe);
    });

  let lmio = attachGroupWithoutChildren(groups, options, 'Legendary Moment: Integrated offer').th = "lm";
  let lmtd = attachGroupWithoutChildren(groups, options, 'Legendary Moment: Test Drive').th = "lm";
  let xevr = attachGroupWithoutChildren(groups, options, 'xEV Readiness').th = "lm";

  attachGroup(groups, options, 'Digital readiness');
  attachGroup(groups, options, 'Excitement');

  options.find(x => x.KpiGroupName == 'Digital readiness').children.find(x => x.label == 'My BMW/MINI App').th = "lm";
  return options;
};

function getFullKpiCollection(groups) {
  let options = [];
  for (const group of groups) {
    attachGroup(groups, options, group.KpiGroupName);
  }
  return options;
};

function attachGroupWithoutChildren(groups, options, groupName) {
  let grp = { ...groups.find(x => x.KpiGroupName == groupName) };
  grp.children = undefined;
  options.push(grp);
  return grp;
};

function attachGroup(groups, options, groupName) {
  let grp = { ...groups.find(x => x.KpiGroupName == groupName) };
  grp.children.forEach(grp => { grp.KpiGroupName = groupName; });
  options.push(grp);
  return grp;
};

export default {
  methods: {
    /// get custom ordered list of KPI (BMW)
    getFilteredCxKpi(groups) {
      let isBMW = guessClient(groups);
      return { 
        selected: selectItem(groups, isBMW),
        items: !isBMW 
          ? getFullKpiCollection(groups)
          : getBmwKpiCollection(groups)
      };
    },

    getBmwBrandItems(data) {
      let result = {};

      let brands = [];
      for (const folder of data) {
        if (!folder.children) {
          brands.push(folder.id);
          continue;
        }
        
        for (const group of folder.children) {
          group.children.forEach(child => {
            if (child.id.startsWith('n') || child.id.startsWith('u')) {
              brands.push(child.id.substring(1));
            } else {
              brands.push(child.id);
            }
          });
        }
      }

      result.bmwmotorrad = brands.filter(id => id.includes('^BMW Motorrad')).join('|'); 
      brands = brands.filter(id => !id.includes('^BMW Motorrad'));
      result.mini = [...new Set(brands.filter(id => id.includes('MINI')))].join('|'); 
      brands = brands.filter(id => !id.includes('MINI'));
      result.bmw = [...new Set(brands)].join('|'); 
      result.ready = true;
      return result;
    }
  }
};
